import { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import AppRouter from './router/Router';
// react query
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';

// styles
import 'react-toastify/dist/ReactToastify.css';
import { decryptJson } from './utils/decryptJson';
import AppModal from './components/global/AppModal';
import PaymentModal from './components/global/PaymentGatewayModal';
import { useLocation } from 'react-router-dom';
import Cookies from './components/Cookies';
import { validateBVN } from './utils/validateOwnerInputs';
import { baseUrl_, landingPageUrl } from './utils/constants';
import ReactGA from 'react-ga4';

const queryClient = new QueryClient();

// function loadScript(src: string) {
//     console.log({ src })
//     return new Promise((resolve) => {
//         const script = document.createElement("script")
//         Object.assign(script, {
//             type: "text/javascript",
//             async: true,
//             src,
//         })
//         script.addEventListener("load", () => {
//             resolve(script)
//         })
//         document.head.appendChild(script)
//     })
// }

const App = () => {
  const [show, setShow] = useState(false);
  const [clickedOk, setClickedOk] = useState(false);
  const [cookieAccepted, setcookieAccepted] = useState(localStorage.getItem('cookieAccepted'));
  document.addEventListener('mousemove', () => {
    localStorage.setItem('lastActvity', Date.now().toString());
  });

  document.addEventListener('keypress', () => {
    localStorage.setItem('lastActvity', Date.now().toString());
  });
  document.addEventListener('click', () => {
    localStorage.setItem('lastActvity', Date.now().toString());
  });

  ReactGA.initialize('G-1JQ0XJZQGK');

  useEffect(() => {
    localStorage.setItem('lastActvity', Date.now().toString());
  }, []);

  useEffect(() => {
    setcookieAccepted(localStorage.getItem('cookieAccepted'));
  }, [clickedOk]);

  const ss = useLocation();

  const timeInterval = setInterval(() => {
    const lastAcivity = localStorage.getItem('lastActvity') ?? '';
    const diffMs = Math.abs(lastAcivity ? +lastAcivity - Date.now() : 0); // milliseconds between now & last activity
    const seconds = Math.floor(diffMs / 1000);
    const minute = Math.floor(seconds / 60);
    if (minute == 5) {
      clearInterval(timeInterval);
      localStorage.removeItem('lastActivity');
      localStorage.removeItem('login-token');
      localStorage.removeItem('login-email');
      localStorage.removeItem('login-phone');
      localStorage.removeItem('sessId');
      localStorage.removeItem('paymentToken');
      localStorage.removeItem('package');
      localStorage.removeItem('package-price');
      localStorage.removeItem('package-id');
      localStorage.removeItem('businessId');
      window.location.reload();
    }
  }, 1000);

  const makeBroadCast = () => {
    const broadcast = new BroadcastChannel('bsfbroadcast');
    const exception = [
      '/flutterwave-payment-completed',
      '/registration/entrepreneur/payment',
      '/new-password',
      // '/privacy-policy'
    ];
    broadcast.postMessage('bsfchannel1');
    broadcast.onmessage = (event) => {
      if (event.data === 'bsfchannel1') {
        broadcast.postMessage(`channelactive`);
      }
      if (event.data === `channelactive`) {
        //specify action
        if (!exception.includes(ss.pathname)) {
          setShow(true);
        }
      }
    };
  };

  // const initScript = () => {
  //     const src = "https://cdnt.netcoresmartech.com/smartechclient.js"; // Change to HTTPS
  //     return loadScript(src);
  // };

  // useEffect(() => {
  //     initScript().then((res) => console.log(res));
  // }, []);

  useEffect(() => {
    makeBroadCast();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <div className='App'>
        <AppRouter />
        {!cookieAccepted && <Cookies setClickedOk={setClickedOk} />}
        <ToastContainer
          position='top-right'
          autoClose={10000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>

      <AppModal show={show} />
    </QueryClientProvider>
  );
};

export default App;
